import { ApiAuth, ApiCall } from "./api";
import { TPremiseResponse } from "./interface/IDefaults";

/**
 * Get Resources
 * @param guid_client Client ID
 * @returns
 */
// GEN-4021: o menu e as rotas por jurisdição esperam esta resposta (fail-closed). Sem teto próprio
// ela herdaria os 20 min do `ApiAuth` — uma requisição pendurada esconderia Certidões, Caixa Postal e
// Conta Corrente sem o aviso de "Tentar novamente", que só aparece quando a chamada termina em erro.
export const RESOURCES_TIMEOUT_MS = 15000;

export const getResources = async (guid_client: string): Promise<TPremiseResponse<string[]>> => {
  return await new ApiCall(`/resources/${guid_client}`, { ...ApiAuth(), timeout: RESOURCES_TIMEOUT_MS }).get();
};
